const MAX_RECENTLY_SEEN = 12;
const STORAGE_PREFIX = "recently_seen_products";

const getStorageKey = (userId) => {
  const scope = userId ? String(userId) : "anon";
  return `${STORAGE_PREFIX}:${scope}`;
};

export const getRecentlySeenProducts = (userId) => {
  try {
    const raw = window.localStorage.getItem(getStorageKey(userId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((entry) => entry && entry._id);
  } catch {
    return [];
  }
};

export const addRecentlySeenProduct = (userId, product) => {
  if (!product || !product._id) return;
  const current = getRecentlySeenProducts(userId);
  const withoutCurrent = current.filter(
    (entry) => String(entry._id) !== String(product._id)
  );
  const next = [product, ...withoutCurrent].slice(0, MAX_RECENTLY_SEEN);
  window.localStorage.setItem(getStorageKey(userId), JSON.stringify(next));
};

